import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LabelConfigModel } from '../helpers/objects/label-config-model';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { SharedSettingsService } from '@fh-client-interaction-frontends/fh-configurations';

@Component({
  selector: 'ui-fh-label',
  templateUrl: './fh-label.component.html',
  styleUrls: ['./fh-label.component.scss']
})
export class FhLabelComponent implements OnInit, OnChanges {
  appConfig: EnvironmentModel = new EnvironmentModel();
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() class: string = '';
  @Input() info: string = '';
  @Input() containerClass: string = '';
  @Input() style: 'SIMPLE' | 'STYLISH' | undefined = undefined;
  @Input() labelConfig: LabelConfigModel = new LabelConfigModel();
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();
  @Input() bootstrap = '';
  @Input() finishedLoading: boolean = false;
  @Input() light: boolean = false;
  @Input() center: boolean = false;
  @Input() textSize = 'medium';

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private sharedSettingsService: SharedSettingsService) {
    this.appConfig = appConfigTemp;
  }

  ngOnInit() {
    this.getLocalSettings();
    this.initData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['label'] || changes['value'] || changes['style'] || changes['class']) {
      this.initData();
    }
  }

  initData() {
    if (this.label != '' && this.label != undefined) {
      this.labelConfig.label = this.label;
    }
    if (this.value != '' && this.value != undefined) {
      this.labelConfig.value = this.value;
    }
    if (this.style != undefined) {
      this.labelConfig.type = this.style;
    }
    if (this.labelConfig.class == '' && this.class != '') {
      this.labelConfig.class = this.class;
    }
  }

  onClick() {
    this.clickEvent.emit();
  }

  shouldShowContent(): any {
    return this.labelConfig.type === 'STYLISH' && this.finishedLoading;
  }

  shouldShowSkeleton(): any {
    return this.labelConfig.type === 'STYLISH' && !this.finishedLoading;
  }

  getLocalSettings() {
    this.sharedSettingsService.get().subscribe({
      next: (value: any) => {
        if (this.textSize != 'medium') {
          return;
        }

        this.textSize = value?.textSize;

        if (this.textSize) {
          this.applyFontSizeClass();
        }
      }
    });
  }

  applyFontSizeClass() {
    document.body.classList.remove('font-size-small', 'font-size-medium', 'font-size-large');
    document.body.classList.add(`font-size-${this.textSize}`);
  }
}
